import { RESET_PASSWORD } from '@/constants/urls';
import { getCoreApi } from '@/utility/getCoreApi';

import apiRequest from '../apiRequest';

export interface IResetPassword {
  new_password: string;
  reset_token: string;
}

export const resetPassword = async (data: IResetPassword) => {
  await apiRequest(
    {
      url: `${getCoreApi()}${RESET_PASSWORD}`,
      method: 'POST',
      data,
    },
    true,
    false,
  );
};

export const getResendUserCredentials = async () => {
  return await apiRequest<void>(
    {
      url: `${getCoreApi()}/auth/creds/resend`,
      method: 'POST',
    },
    true,
    false,
  );
};
